// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__bAC3G","description":"MealItem_description__--eOM","price":"MealItem_price__CjpHy"};